import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import '@hostbuddy-frontend-dev/inbox/style.css';
import Loader from 'components/loader/Loader';
import InboxContextProvider from './InboxContextProvider';
import InboxBody from './InboxBody';
import useHasHostfullyAssistEnabledProperties from './useHasHostfullyAssistEnabledProperties';
import HostbuddyInboxWrapper from './assist/HostbuddyInboxWrapper';

const Inbox = () => {
  const [searchParams] = useSearchParams();
  const { hasHostfullyAssistEnabledProperties, isLoading: isAssistLoading } =
    useHasHostfullyAssistEnabledProperties();
  const inboxBody = useMemo(() => <InboxBody />, []);

  if (isAssistLoading) {
    return <Loader />;
  }

  const renderHostbuddyInbox =
    !searchParams.get('legacy') && hasHostfullyAssistEnabledProperties;

  if (renderHostbuddyInbox) {
    return <HostbuddyInboxWrapper />;
  }

  return <InboxContextProvider>{inboxBody}</InboxContextProvider>;
};

export default Inbox;
